<section alertContainer>
  <section
    class="flex flex-col items-center justify-center w-full gap-3 select-none"
  >
    <p class="self-center text-xl font-semibold text-gray-800">계정 연결</p>
  </section>
  <p class="text-sm text-center text-gray-600">
    이미 가입된 계정입니다 <br />
    연결하시겠습니까?
  </p>
  <section class="flex gap-3 items-center">
    <app-button (click)="close()" expand color="white" variant="outline"
      >취소</app-button
    >
    <app-button (click)="confirm()" expand>확인</app-button>
  </section>
</section>
